var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift"},[_c('div',{staticClass:"gift-tie-1"}),_c('div',{staticClass:"gift-tie-2"}),_c('div',{staticClass:"gift-top"}),_c('div',{staticClass:"gift-body"})])
}]

export { render, staticRenderFns }